// extracted by mini-css-extract-plugin
module.exports = {"live":"live_live_et-H1","serach":"live_serach_TvFt_","total":"live_total_1SRbg","table":"live_table_2dfl4","operation":"live_operation_1wxyn","render":"live_render_rdZAD"};